<template>
    <div>
        <div class="relative">
            <button
                type="button"
                ref="buttonRef"
                class="btn btn-secondary min-h-10 flex items-center gap-2.5"
                :class="{ '!border-0 !shadow-none': !showBorder }"
                @click="showMore = !showMore"
                v-click-outside="() => (showMore = false)"
            >
                <Icon icon="dots-vertical" />
                <span v-if="showLabel">More</span>
            </button>
            <transition name="fade">
                <div
                    ref="popoverRef"
                    :style="floatingStyles"
                    class="z-30"
                    v-if="showMore"
                >
                    <div class="bg-white p-3 rounded-lg shadow">
                        <ul class="text-sm">
                            <li>
                                <button
                                    class="px-2 py-1 text-lef flex items-center gap-2"
                                    @click="showRedemption()"
                                >
                                    <Icon
                                        icon="eye-on"
                                        :width="16"
                                        :height="16"
                                    />
                                    <span>View</span>
                                </button>
                            </li>
                            <li>
                                <button
                                    class="px-2 py-1 text-lef flex items-center gap-2"
                                    @click="editRedemption()"
                                >
                                    <Icon
                                        icon="edit"
                                        :width="16"
                                        :height="16"
                                    />
                                    <span>Edit</span>
                                </button>
                            </li>
                            <li v-if="showShare">
                                <button
                                    class="px-2 py-1 text-left flex items-center gap-2"
                                >
                                    <Icon
                                        icon="share"
                                        :width="16"
                                        :height="16"
                                    />
                                    <span>Share</span>
                                </button>
                            </li>
                            <li>
                                <button
                                    class="px-2 py-1 text-left flex items-center gap-2"
                                    @click="showDeleteConfirmation = true"
                                >
                                    <Icon
                                        icon="trash"
                                        :width="16"
                                        :height="16"
                                    />
                                    <span>Delete</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </transition>
        </div>
        <Teleport to="body">
            <ConfirmDialag
                :show="showDeleteConfirmation"
                title="Delete Redemption"
                dialog="You are about to delete the redemption? This action cannot be undone."
                :buttons="[
                    {
                        type: 'cancel',
                        text: 'Cancel',
                    },
                    {
                        type: 'confirm',
                        text: 'Delete redemption',
                        value: true,
                    },
                ]"
                @cancel="showDeleteConfirmation = false"
                @confirm="deleteRedemption"
            />
        </Teleport>
    </div>
</template>
<script setup>
import { useTripsStore } from '@/store/trips';
import { ref } from 'vue';
import { useFloating, flip, offset, shift } from '@floating-ui/vue';

import ConfirmDialag from '@/components/ui/confirmation-dialog/confirmation-dialog.vue';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    redemption: {
        type: Object,
    },
    showLabel: {
        type: Boolean,
        default: true,
    },
    showShare: {
        type: Boolean,
        default: true,
    },
    showBorder: {
        type: Boolean,
        default: true,
    },
});

const tripsStore = useTripsStore();
const showMore = ref(false);
const showDeleteConfirmation = ref(false);
const buttonRef = ref(null);
const popoverRef = ref(null);
const { floatingStyles } = useFloating(buttonRef, popoverRef, {
    placement: 'bottom-end',
    middleware: [offset(10), flip(), shift(5)],
});

const showRedemption = () => {
    tripsStore.setActiveRedemption(props.redemption);
    tripsStore.setPanelRedemption(props.redemption);
    tripsStore.setShowRedemptionPanel(true);
};

const editRedemption = () => {
    tripsStore.setActiveRedemption(props.redemption);
    tripsStore.setShowRedemptionEditModal(true);
};

const deleteRedemption = () => {
    tripsStore.deleteRedemption(props.redemption.uuid);
};
</script>
